module.exports = __webpack_public_path__ + "static/media/ornaments.a5561e81.jpg";